// @DEV: add "?opennav=<nav>" parameter to auto open for dev. Example: https://localhost:3002/?opennav=services
let timeoutId = null;
export default($el) => ({
  active: $el.dataset.autoOpen ?? '',
  mobileOpen: false,
  isVisible: Boolean($el.dataset.open) ?? false,
  bodyOpenClass: 's-menu-open',
  open: Boolean($el.dataset.open) ?? false,
  timer: 200,           // close the menu after 200ms
  init(){
    const els = $el.querySelectorAll('.js-not-ready')
    els.forEach(el => {
      el.classList.remove('js-not-ready')
    })
  },
  handleLeave() {
    timeoutId = setTimeout(() => {
      this.active = ''
      this.open = false
      this.isVisible = false
      this.updateStates()
    }, this.timer);
  },
  clearTimeout() {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  },
  handleMobile($event) {
    $event.preventDefault()
    this.mobileOpen = !this.mobileOpen
    this.updateStates();
  },
  handleChange($event) {
    this.clearTimeout()
    $event.preventDefault()
    const { currentTarget } = $event
    const navItem = currentTarget.dataset.navItem
    if(!navItem) {
      return
    }
    if(this.active === false) this.active = navItem;
    if(this.active === navItem) {
      if($event.type === 'click') {
        this.active = ''
        this.open = false
        this.isVisible = false
      }
      this.updateStates()
      return
    }
    this.open = true
    this.isVisible = false
    setTimeout(() => {
      this.isVisible = true
      this.updateStates()
    }, 0);
    this.active = navItem;
  },
  updateStates() {
    const body = document.body;
    const htmlElement = document.documentElement; // boilerplate from original design requires this
    const carouselInstances = window.caroInstances;
    const isMobileOrVisible = this.mobileOpen || this.isVisible;

    if (isMobileOrVisible) {
      body.classList.add(this.bodyOpenClass);
      htmlElement.classList.add(this.bodyOpenClass);
    } else {
      body.classList.remove(this.bodyOpenClass);
      htmlElement.classList.remove(this.bodyOpenClass);
    }

    if (Array.isArray(carouselInstances)) {
      carouselInstances.forEach(instance => {
        if (instance.options.autoPlay) {
          isMobileOrVisible ? instance.stopPlayer() : instance.playPlayer();
        }
      });
    }
  }

})
